import { AppNotificationDelegate } from './app_notification_service';
import { IPopupConfigService } from '../vendor/ui-ng-popup/src/main';
angular
  .module('lib')
  .run((log: any, appNotificationDelegate: AppNotificationDelegate, ngPopupService: IPopupConfigService) => {
    log.on('issue', (entry: { message: string }) => {
      appNotificationDelegate.warn(entry.message);
    });
    // TODO: standarize all notification syntax. `log.issue` should log to console, `log.user.issue` should display to user
    log.user.on('issue', (entry: { message: string }) => {
      appNotificationDelegate.warn(entry.message);
    });
    log.user.on('success', (entry: { message: string }) => {
      appNotificationDelegate.success(entry.message);
    });
    log.on('prompt', (entry: { message: any }) => {
      ngPopupService.show(entry.message);
    });
  });



// WEBPACK FOOTER //
// ./app/lib/issue_notifications.ts